import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef, ViewEncapsulation } from '@angular/core';
import { PlycaUiButtonGenericComponent } from '../../../atoms/buttons/button-generic/button-generic.component';
import { BannerGenericConfig } from '../_config/banner.model';

@Component({
  selector: 'plyca-ui-banner-generic',
  templateUrl: './banner-generic.component.html',
  styleUrl: './banner-generic.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiButtonGenericComponent]
})
export class PlycaUiBannerGenericComponent {
  public config: InputSignal<BannerGenericConfig> = input.required<BannerGenericConfig>();
  public clickEvent: OutputEmitterRef<Event> = output<Event>();

  public handleClick(event: Event): void {
    this.clickEvent.emit(event);
  }
}
